// 非 React 的 Modal.confirm（DOM 操作）

export const DOMModal = {
  confirm: (options: {
    title?: string;
    content: string;
    onOk?: () => void;
    onCancel?: () => void;
    okText?: string;
    cancelText?: string;
  }) => {
    const {
      title = 'Confirm',
      content,
      onOk,
      onCancel,
      okText = 'OK',
      cancelText = 'Cancel',
    } = options;

    const overlay = document.createElement('div');
    overlay.className = 'fixed inset-0 bg-black/60 z-[9998] flex items-center justify-center p-4';
    overlay.style.animation = 'fadeIn 0.2s ease';

    const modal = document.createElement('div');
    modal.className = 'bg-dark-800 rounded-xl shadow-2xl max-w-md w-full border border-dark-700';
    modal.innerHTML = `
      <div class="p-6">
        <h3 class="text-lg font-semibold text-white mb-2">${title}</h3>
        <div class="text-dark-300 mb-6 text-sm leading-relaxed">${content}</div>
        <div class="flex justify-end gap-3">
          <button class="tw-modal-cancel px-4 py-2 rounded-lg border border-dark-600 text-dark-300 hover:bg-dark-700 transition-colors text-sm font-medium">${cancelText}</button>
          <button class="tw-modal-ok px-4 py-2 rounded-lg bg-primary-600 text-white hover:bg-primary-500 transition-colors text-sm font-medium">${okText}</button>
        </div>
      </div>
    `;
    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    const remove = () => {
      overlay.classList.add('opacity-0');
      setTimeout(() => overlay.remove(), 200);
    };
    modal.querySelector('.tw-modal-ok')!.addEventListener('click', () => {
      remove();
      if (onOk) onOk();
    });
    modal.querySelector('.tw-modal-cancel')!.addEventListener('click', () => {
      remove();
      if (onCancel) onCancel();
    });
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        remove();
        if (onCancel) onCancel();
      }
    });
  },
};
